// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.org-chart-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  width: 100%;
}

.org-chart-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  text-align: center;
  width: min(100%, 16.5rem);
  padding: 1.25rem 1.35rem;
  border-radius: 1.35rem;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 18px 35px rgba(15, 23, 42, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.org-chart-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 22px 45px rgba(15, 23, 42, 0.18);
}

.org-chart-details {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.org-chart-name {
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.4;
}

.org-chart-email {
  font-size: 0.85rem;
  color: inherit;
  opacity: 0.8;
}

.org-chart-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
}

.org-chart-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.35rem 0.75rem;
  border-radius: 9999px;
  transition: background 0.2s ease, color 0.2s ease;
}

.org-chart-tag svg {
  font-size: 0.85rem;
}

.org-chart-toggle {
  margin-top: 0.25rem;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.7rem;
  font-weight: 600;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.org-chart-toggle:hover {
  transform: translateY(-1px);
}

.org-tag-warning {
  background: rgba(251, 191, 36, 0.25);
  color: #92400e;
}

.org-card-primary {
  background: linear-gradient(140deg, #10b981, #059669);
  color: #ffffff;
  border-color: rgba(16, 185, 129, 0.45);
  box-shadow: 0 24px 45px rgba(16, 185, 129, 0.35);
}

.org-badge-primary {
  background: rgba(255, 255, 255, 0.22);
  color: #ffffff;
}

.org-toggle-primary {
  background: rgba(255, 255, 255, 0.22);
  color: #ffffff;
}

.org-card-secondary {
  background: linear-gradient(140deg, #facc15, #f59e0b);
  color: #713f12;
  border-color: rgba(250, 204, 21, 0.5);
}

.org-badge-secondary {
  background: rgba(255, 255, 255, 0.8);
  color: #92400e;
}

.org-toggle-secondary {
  background: rgba(255, 255, 255, 0.9);
  color: #92400e;
}

.org-card-tertiary {
  background: #eff6ff;
  color: #1e3a8a;
  border-color: #bfdbfe;
}

.org-badge-tertiary {
  background: #ffffff;
  color: #1d4ed8;
}

.org-toggle-tertiary {
  background: #dbeafe;
  color: #1d4ed8;
}


.org-chart-children {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;
  padding: 2.5rem 0 1rem;
  width: 100%;
  overflow-x: auto;
}

.org-chart-children::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 2.5rem;
  background: #cbd5e1;
}

.org-chart-child {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 18rem;
  min-width: 15.5rem;
  padding: 2.5rem 1.5rem 0;
  margin: 0;
}

.org-chart-child::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top: 2px solid #cbd5e1;
}

.org-chart-child:first-child::before {
  left: 50%;
}

.org-chart-child:last-child::before {
  right: 50%;
}

.org-chart-child:only-child::before {
  content: none;
}

.org-chart-child::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top: 2px solid #cbd5e1;
}

.org-chart-child:first-child::before {
  left: 50%;
}

.org-chart-child:last-child::before {
  right: 50%;
}

.org-chart-child:only-child::before {
  content: none;
}

.org-chart-child::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 2.5rem;
  background: #cbd5e1;
  z-index: 1;
}

.org-chart-children-single .org-chart-child::before {
  content: none;
}

.org-chart-children-single .org-chart-child {
  flex: 0 0 auto;
  min-width: 0;
  padding: 2.5rem 0 0;
}

@media (max-width: 1024px) {
  .org-chart-card {
    width: min(100%, 15.5rem);
  }

  .org-chart-child {
    flex: 1 1 16rem;
    min-width: 14rem;
    padding: 2.25rem 1rem 0;
  }
}

@media (max-width: 768px) {
  .org-chart-card {
    width: min(100%, 15rem);
  }

  .org-chart-children {
    flex-wrap: wrap;
    overflow-x: visible;
  }

  .org-chart-child {
    flex: 1 1 14rem;
    min-width: 12rem;
    padding: 2rem 0.75rem 0;
  }
}

@media (max-width: 640px) {
  .org-chart-children {
    padding-top: 1.75rem;
  }

  .org-chart-children::before,
  .org-chart-child::before,
  .org-chart-child::after {
    content: none;
  }

  .org-chart-child {
    flex: 1 1 100%;
    min-width: auto;
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrganizationChart.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,UAAU;EACZ;AACF","sourcesContent":[".org-chart-node {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n  width: 100%;\n}\n\n.org-chart-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  text-align: center;\n  width: min(100%, 16.5rem);\n  padding: 1.25rem 1.35rem;\n  border-radius: 1.35rem;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 18px 35px rgba(15, 23, 42, 0.12);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.org-chart-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 22px 45px rgba(15, 23, 42, 0.18);\n}\n\n.org-chart-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.org-chart-name {\n  font-size: 1.15rem;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.org-chart-email {\n  font-size: 0.85rem;\n  color: inherit;\n  opacity: 0.8;\n}\n\n.org-chart-tags {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.org-chart-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.35rem 0.75rem;\n  border-radius: 9999px;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.org-chart-tag svg {\n  font-size: 0.85rem;\n}\n\n.org-chart-toggle {\n  margin-top: 0.25rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;\n}\n\n.org-chart-toggle:hover {\n  transform: translateY(-1px);\n}\n\n.org-tag-warning {\n  background: rgba(251, 191, 36, 0.25);\n  color: #92400e;\n}\n\n.org-card-primary {\n  background: linear-gradient(140deg, #10b981, #059669);\n  color: #ffffff;\n  border-color: rgba(16, 185, 129, 0.45);\n  box-shadow: 0 24px 45px rgba(16, 185, 129, 0.35);\n}\n\n.org-badge-primary {\n  background: rgba(255, 255, 255, 0.22);\n  color: #ffffff;\n}\n\n.org-toggle-primary {\n  background: rgba(255, 255, 255, 0.22);\n  color: #ffffff;\n}\n\n.org-card-secondary {\n  background: linear-gradient(140deg, #facc15, #f59e0b);\n  color: #713f12;\n  border-color: rgba(250, 204, 21, 0.5);\n}\n\n.org-badge-secondary {\n  background: rgba(255, 255, 255, 0.8);\n  color: #92400e;\n}\n\n.org-toggle-secondary {\n  background: rgba(255, 255, 255, 0.9);\n  color: #92400e;\n}\n\n.org-card-tertiary {\n  background: #eff6ff;\n  color: #1e3a8a;\n  border-color: #bfdbfe;\n}\n\n.org-badge-tertiary {\n  background: #ffffff;\n  color: #1d4ed8;\n}\n\n.org-toggle-tertiary {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n\n.org-chart-children {\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: stretch;\n  padding: 2.5rem 0 1rem;\n  width: 100%;\n  overflow-x: auto;\n}\n\n.org-chart-children::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 2.5rem;\n  background: #cbd5e1;\n}\n\n.org-chart-child {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1 1 18rem;\n  min-width: 15.5rem;\n  padding: 2.5rem 1.5rem 0;\n  margin: 0;\n}\n\n.org-chart-child::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 2px solid #cbd5e1;\n}\n\n.org-chart-child:first-child::before {\n  left: 50%;\n}\n\n.org-chart-child:last-child::before {\n  right: 50%;\n}\n\n.org-chart-child:only-child::before {\n  content: none;\n}\n\n.org-chart-child::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 2px solid #cbd5e1;\n}\n\n.org-chart-child:first-child::before {\n  left: 50%;\n}\n\n.org-chart-child:last-child::before {\n  right: 50%;\n}\n\n.org-chart-child:only-child::before {\n  content: none;\n}\n\n.org-chart-child::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 2.5rem;\n  background: #cbd5e1;\n  z-index: 1;\n}\n\n.org-chart-children-single .org-chart-child::before {\n  content: none;\n}\n\n.org-chart-children-single .org-chart-child {\n  flex: 0 0 auto;\n  min-width: 0;\n  padding: 2.5rem 0 0;\n}\n\n@media (max-width: 1024px) {\n  .org-chart-card {\n    width: min(100%, 15.5rem);\n  }\n\n  .org-chart-child {\n    flex: 1 1 16rem;\n    min-width: 14rem;\n    padding: 2.25rem 1rem 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .org-chart-card {\n    width: min(100%, 15rem);\n  }\n\n  .org-chart-children {\n    flex-wrap: wrap;\n    overflow-x: visible;\n  }\n\n  .org-chart-child {\n    flex: 1 1 14rem;\n    min-width: 12rem;\n    padding: 2rem 0.75rem 0;\n  }\n}\n\n@media (max-width: 640px) {\n  .org-chart-children {\n    padding-top: 1.75rem;\n  }\n\n  .org-chart-children::before,\n  .org-chart-child::before,\n  .org-chart-child::after {\n    content: none;\n  }\n\n  .org-chart-child {\n    flex: 1 1 100%;\n    min-width: auto;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
